<template>
    <div>

		<div class="title">
			<p class="main">Kitchen Confidential by Anthony Bourdain</p>
			<div class="subheadings">
				<p class="published-date">17th April 2026</p>
				
				
			</div>
		</div>

		<div class="article">
			<p>Finally a bit of light relief!</p>

			<p>I wasn’t that into food or cooking as a younger guy and so my first exposure to Anthony Bourdain was when he died, sadly. I’ve since gone back and watched some of his shows and his enthusiasm is infectious. His obvious love for Glasgow chip shops certainly improved my opinion of him but that’s by the by.</p>

			<p>Kitchen Confidential isn’t a cookbook or a memoir. It’s a peak behind the curtain. It’s telling you “Look, you may like eating, but these guys like food” and that’s the difference. The book opens with Bourdain as a kid on holiday in France. Terrified of anything that was a cheeseburger (and even then, afraid of the French cheese) he is embarrassed by being left behind when his parents visit a “fancy” restaurant. Why couldn’t he enjoy it? And so he deliberately becomes brave. His description of his first oyster made me think maybe I like oysters when I know I don’t which should give you an idea of the power of the prose.</p>

			<p>I don’t have a lot to say about Kitchen Confidential. It’s just fun. Every chapter has new and more amazing characters. Every one imparts something on Bourdain that lead to him becoming a successful, though by his own admission not a truly great, chef. He shies away from giving advice or telling you how things should be done. He tells you how they are done. The most long lived line from this book is that you shouldn’t order fish on a Monday because it’ll be three days old. That’s the extent of what one can take away in a culinary sense.</p>

			<p>The book is about more than that. It’s kind of about how to love what you love be it food, music, gardening… whatever. If you’re going to do it, do it right. Commit to the bit. Learn the secret language. Improve it where you can, if you can. And if not who cares? Still try stuff.</p>

			<p>It’s a shame that that feeling couldn’t sustain Bourdain for longer than it did. But from the first page where he talks about the Damacene moment of his first oyster, you do think… maybe I like oysters, even if you know you don’t.</p>


		</div>


    </div>
</template>


<script>

	export default {
		name: "KitchenConfidentialArticle"
	}

</script>


<style>

</style>